export default "__VITE_ASSET__DtLcXMI0__"